import React, { useState, useEffect,useRef, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import Select from "react-select"
// D:\projects\twt_frontend\twt_ui\src\assets\css\inventorymanagement.css
import '../../assets/css/inventorymanagement.css'

const FinishedGoodsInventory = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null)
  const [rowData, setRowData] = useState([]);
  const [currentSkuCode,setCurrentSkuCode] = useState("")
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState("")
  const [currentUploadedDate, setCurrentUploadedDate] = useState("")
  const [prevDate, setPrevDate] = useState("")
  const [currentDestinationId,setCurrentDestinationId] = useState("")
  const gridApi = useRef(null); // Reference for the grid API
  const gridColumnApi = useRef(null); // Reference for the column API
  const [editFormData, setEditFormData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    unit_of_measure: "",
    minimum_order_quantity: "",
  });
  const [duplicatedEditData, setDuplicatedEditData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    unit_of_measure: "",
    minimum_order_quantity: "",
  });

  const [skuCode, setSkuCode] = useState({label : "ALL", value : ""});
  const [storeId, setStoreId] = useState({label : "ALL", value : ""}); 
  const [skuOptions,setSkuOptions] = useState([{label : "ALL", value : ""}])
  const [prevStoreId, setPrevStoreId] = useState({label : "ALL", value : ""})
  const [storeOptions,setStoreOptions] = useState([{label : "ALL", value : ""}])

  const columnWithDefs = [
    { headerName: "WH SKU Batch", field: "whskubatch", sortable: true },
    { headerName: "Destination Store ID", field: "destination_store_id", sortable: true },
    { headerName: "Destination Store Name", field: "destination_store_name", sortable: true },
    { headerName: "Manufacturing Date", field: "m_date", sortable: true },
    { headerName: "Expiry Date", field: "e_date", sortable: true },
    { headerName: "Day Completed", field: "day_completed", sortable: true },
    { headerName: "Day Left", field: "day_left", sortable: true },
    { headerName: "Warehouse", field: "warehouse", sortable: true },
    { headerName: "SKU Code", field: "sku_code", sortable: true },
    { headerName: "Sale Quantity (units) ", field: "sale_quantity", sortable: true },
    { 
    headerName: "Invoice Date", 
    field: "invoice_date", 
    filter: "agDateColumnFilter", 
    valueFormatter: (params) => {
      const date = new Date(params.value);
      return date.toISOString().split('T')[0]; // Formats the date as YYYY-MM-DD
    },
  },
  ];


  // onGridReady handler (for when the grid is initialized)
  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;

    // Auto-size columns when the grid is ready
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns && allColumns.length > 0) {
        const allColumnIds = allColumns.map(col => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };


  const autoSizeAllColumns = () => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns && allColumns.length > 0) {
        const allColumnIds = allColumns.map(col => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  }

    // onFirstDataRendered handler (for when the first data is rendered)
  const onFirstDataRendered = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    autoSizeAllColumns();
  };


  const resetFilters = () => {
    setSkuCode({label : "ALL", value : ""})
    setStoreId({label : storeOptions[0]["label"], value : ""})
  };  
  
  const resetFormData = () => {
   setEditFormData( {
        sku_code: "",
        sku_name: "",
        sku_category: "",
        unit_of_measure: "",
        minimum_order_quantity: "",
      })
      setDuplicatedEditData({
          sku_code: "",
          sku_name: "",
          sku_category: "",
          unit_of_measure: "",
          minimum_order_quantity: "",
      })
  }

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("")
    setUploadedFileData([]);
  };




  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
      statusPanels: [
          {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left"
          },
          {
              statusPanel: "agTotalRowCountComponent",
              align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
      ]
  }

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getSkuMasterData = async () => {
    try{
      const response = await redirectURL.post("inventory/getFGInventoryData", {})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          const formattedDate = response.data.date
          ? new Date(response.data.date).toISOString().split('T')[0]
          : '';
          resetFilters()
          setCurrentInvoiceDate(formattedDate);
          setTimeout(() => autoSizeAllColumns(), 0);
          // setLoadshow("show-n");
          // setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          // setBasicTitle("No Historic  data found");
          // setBasicType("info");
          // setShow(true);
        }
      }
    }
    catch (error) {
      console.error("Error fetching Finished Goods Inventory data:", error);
      setBasicTitle("Failed to fetch Finished Goods Inventory data");
      setBasicType("error");
      setShow(true);
    }
  }

    const resetgetSkuMasterData = async () => {
    try{
      const response = await redirectURL.post("inventory/getFGInventoryData", {})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const defaultData = response.data.data.filter(item => item.destination_store_id === storeOptions[0]["value"]);

          setRowData(defaultData);
          const formattedDate = response.data.date
          ? new Date(response.data.date).toISOString().split('T')[0]
          : '';
          resetFilters()
          setCurrentInvoiceDate(formattedDate);
          setTimeout(() => autoSizeAllColumns(), 0);
          // setLoadshow("show-n");
          // setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          // setBasicTitle("No Historic  data found");
          // setBasicType("info");
          // setShow(true);
        }
      }
    }
    catch (error) {
      console.error("Error fetching Finished Goods Inventory data:", error);
      setBasicTitle("Failed to fetch Finished Goods Inventory data");
      setBasicType("error");
      setShow(true);
    }
  }
const getSkuMasterDataByFilters = async () => {
    try{
      var params = {}
      params.invoice_date = currentinvoiceDate ?  currentinvoiceDate : ""
      params.destination_store_id = storeId.value ?  storeId.value : ""
      params.sku_code = skuCode.value ?  skuCode.value : ""

      const response = await redirectURL.post("inventory/getFGInventoryFilters", params)
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setLoadshow("show-n");
          setOverlayBlock("show-n");

        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setBasicTitle("No Finished Goods Inventory data found");
          setBasicType("info");
          setShow(true);
        }
      }

    }
    catch (error) {
      console.error("Error fetching Finished Goods Inventory data:", error);
      setBasicTitle("Failed to fetch Finished Goods Inventory data");
      setBasicType("error");
      setShow(true);
    }
}
const getSkuMasterDataByFilters2 = async (options) => {
    try{
      var params = {}
      params.invoice_date = currentinvoiceDate ?  currentinvoiceDate : ""
      params.destination_store_id = storeId.value ?  storeId.value : ""
      params.sku_code = skuCode.value ?  skuCode.value : ""

      const response = await redirectURL.post("inventory/getFGInventoryFilters", params)
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const defaultData = response.data.data.filter(item => item.destination_store_id === options[0]["value"])
          setRowData(defaultData);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setBasicTitle("No Finished Goods Inventory data found");
          setBasicType("info");
          setShow(true);
        }
      }

    }
    catch (error) {
      console.error("Error fetching Finished Goods Inventory data:", error);
      setBasicTitle("Failed to fetch Finished Goods Inventory data");
      setBasicType("error");
      setShow(true);
    }
    onGridReady()
}

const getDistinctStoreIdsByDate = async () => {
    try{
      const response = await redirectURL.post("inventory/getFGInventoryDistinctStoreIds", {invoice_date : currentinvoiceDate})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          // setStoreId({label : "Loading...", value : "loading"})
          const distinctOptions = response.data.data
          // distinctOptions.unshift({label : "ALL", value : ""})
          setStoreId({label : distinctOptions[0]["label"], value :distinctOptions[0]["value"]})
          getSkuMasterDataByFilters2(distinctOptions)
          setStoreOptions(distinctOptions)
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setBasicTitle("No Finished Goods Inventory data found");
          setBasicType("info");
          setShow(true);
        }
      }
    }
    catch (error) {
      // console.error("Error fetching Historic  data:", error);
      setBasicTitle("Failed to fetch Finished Goods Inventory data");
      setBasicType("error");
      setShow(true);
    }
}

const getDistinctSkuCodes = async ()=> {
    try{

      var params = {
        invoice_date : currentinvoiceDate,
        destination_store_id : storeId.value,
      }

      const response = await redirectURL.post("inventory/getFGInventoryDistinctSkuCodes", params)
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {

          const distinctOptions = response.data.data.map(item => ({label : item, value : item}))
          distinctOptions.unshift({label : "ALL", value : ""})

          setSkuCode({label : "ALL", value : ""})
          setSkuOptions(distinctOptions)
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
           setLoadshow("show-n");
           setOverlayBlock("show-n");
          // setBasicTitle("No Historic  data found");
          // setBasicType("info");
          // setShow(true);
        }
      }
    }
    catch (error) {
      // console.error("Error fetching Historic  data:", error);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch Finished Goods Inventory data");
      setBasicType("error");
      setShow(true);
    }
}

const getMainData = async () => {
    setLoadshow("show-m");  
    setOverlayBlock("show-m");
    await resetgetSkuMasterData()
    setLoadshow("show-n");  
    setOverlayBlock("show-n");
}


  useEffect(() => {
    const getData = async () => {
      if(!rowData.length > 0) {
        await getMainData()
      }
    }
    getData()
  }, []);

  useEffect(() => {
    const getData = async () => {
      if (prevDate !== currentinvoiceDate) {
        // setLoadshow("show-m");  
        // setOverlayBlock("show-m");
        await getDistinctStoreIdsByDate()
        setLoadshow("show-n");  
        setOverlayBlock("show-n");
      }
     
      }

    getData()
  }, [currentinvoiceDate])


  useEffect(() => {
    const getData = async () => {
      if (prevDate !== currentinvoiceDate && prevStoreId.value !== storeId.value) {
        // setLoadshow("show-m");  
        // setOverlayBlock("show-m");
        await getDistinctSkuCodes()
        setLoadshow("show-n");  
        setOverlayBlock("show-n");
      }
      
      }

    getData()
  }, [currentinvoiceDate , storeId.value])


const closeAlert = () => {
 const fileInput = document.getElementById("bulkUploadFile");
   if (fileInput !== null) {  // Check if the element exists
    fileInput.value = "";  // Clears the input if element exists
  }

  setUploadedFileData([]);
  setShow(false);
  setLoadshow("show-n");
  setOverlayBlock("show-n");
  setOverlyBlock("show-n");
  setShowDeletePopup(false)
  setSliderOpen(false)
  setCurrentUploadedDate("")
  // resetFormData();
};

const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData();
    setUploadedFileData([]);
  };

const downloadExcelTemplate = () => {
    const sampleData = [
      [
        "Destination Store Id",
        "SKU Code",
        "Sale Quantity",
        // "Destination Store Name",
        // "Invoice Date"
      ],
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    writeFile(wb, "sample_historic_template.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value)
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

        const mapping = {
          "Destination Store Id": "destination_store_id",
          // "Destination Store Name" : "destination_store_name",
          "SKU Code": "sku_code",
          "Sale Quantity": "sale_quantity",
        };

        function toSnakeCase(str) {
          return str
            .trim()
            .replace(/\s+/g, '_')           // replace spaces with underscores
            .replace(/[A-Z]/g, letter => letter.toLowerCase()) // lowercase any capitals
            .replace(/[^a-z0-9_]/g, '')     // remove any special chars if needed
        }

        // transform
        const result = parsedData.map(item => {
          const newItem = {};
          for (const key in item) {
            if (mapping[key]) {
              // if in mapping use mapped version
              newItem[mapping[key]] = item[key];
            } else {
              // if not in mapping, convert key to snake_case
              newItem[toSnakeCase(key)] = item[key];
            }
          }
          return newItem;
        });


      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };

  const onClickingFileSubmit = async () => {
    if (uploadedFileData.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file");
      return;
    }

    const params = { date : currentUploadedDate, masterData: uploadedFileData };
      try {
          setLoadshow("show-m");
          setOverlayBlock("show-m");
        const response = await redirectURL.post(
          "inventory/storeFGInventoryData",
          params
        );
       
        if (response.data.status === "success") {
          await getSkuMasterData();
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("success");
          setBasicTitle("Data Uploaded Successfully");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("info");
          setBasicTitle("Data Upload Failed");
        }
        
      } catch (error) {
        const errorMessage = error.response?.data?.message || "Failed to upload data";
        setShow(true);
        setBasicType("info");
        setBasicTitle(errorMessage);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
      }
  };


  const onClickUploadSkuMasterData = (event) => {
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25"); 
    setSliderTitle("Upload FG Inventory Data");
    setOverlyBlock("show-m");
  };

//   const onClickingUpdateSkuData = async () => {
//     setLoadshow("show-m");
//     setOverlayBlock("show-m");
//     const params = {  
//       sku_code: editFormData.sku_code,
//       sku_name: editFormData.sku_name,
//       sku_category: editFormData.sku_category,
//       unit_of_measure: editFormData.unit_of_measure,
//       minimum_order_quantity: parseInt(editFormData.minimum_order_quantity),
//     };  

//     const isNeedtoUpdate = Object.keys(editFormData).filter(
//     (key) => editFormData[key] !== duplicatedEditData[key] && editFormData[key] !== ""
//     )

//     if (!isNeedtoUpdate) {
//       setShow(true);
//       setBasicType("info");
//       setBasicTitle("No changes made to Finished Goods Inventory data or empty keys");
//       setLoadshow("show-n");
//       setOverlayBlock("show-n");
//       return;
//     }
//     try {
//       const response = await redirectURL.post(
//         "masters/updateSkuMasterData",
//         params
//       );

      
//       if (response.data.status === "success") {
//         await getSkuMasterData();
//         setLoadshow("show-n");
//         setOverlayBlock("show-n");
//         setShow(true);
//         setBasicType("success");
//         setBasicTitle("Finished Goods Inventory Data Updated Successfully");
//         // Update the rowData with the new data
//         const updatedRowData = rowData.map((row) =>
//           row.sku_code === editFormData.sku_code ? editFormData : row
//         );
//         setRowData(updatedRowData);
//       } else {
//         setLoadshow("show-n");
//         setOverlayBlock("show-n");
//         setShow(true);
//         setBasicType("info");
//         setBasicTitle("Failed to update Finished Goods Inventory data");
//       }
      
//     } catch (error) {
//       setShow(true);
//       setBasicType("info");
//       setBasicTitle("Failed to update Finished Goods Inventory data");
//     }
//   }

//   const handleAddSkuProduct = async () => {
//     setLoadshow("show-m");
//     setOverlayBlock("show-m");
//     const params = {
//       sku_code: editFormData.sku_code,
//       sku_name: editFormData.sku_name,
//       sku_category: editFormData.sku_category,
//       unit_of_measure: editFormData.unit_of_measure,
//       minimum_order_quantity: parseInt(editFormData.minimum_order_quantity),
//     };
//     console.log("params", params)

//     const validationErrors = Object.keys(params).filter((key) => {
//       const value = params[key];
//       // Apply trim only for string fields
//       if (typeof value === "string") {
//         return !value || value.trim() === "";
//       } else if (value === undefined || value === null || value === "") {
//         return true;
//       }
//       return false;
//     });

//     if (validationErrors.length > 0) {
//       setShow(true);
//       setBasicType("info");
//       setBasicTitle(`Please fill in all required fields: ${validationErrors.join(", ")}`);
//       setLoadshow("show-n");
//       setOverlayBlock("show-n");
//       return;
//     }
//     const validSkuCode = /^[a-zA-Z0-9_-]+$/.test(params.sku_code);  
//     const validatemoq = /^[0-9]+$/.test(params.minimum_order_quantity);
//     if (!validatemoq) {
//       setShow(true);
//       setBasicType("info");
//       setBasicTitle("Minimum Order Quantity must be a valid number");
//       setLoadshow("show-n");
//       setOverlayBlock("show-n");
//       return;
//     }
//     if (!validSkuCode) {
//       setShow(true);
//       setBasicType("info");
//       setBasicTitle("SKU Code can only contain letters, numbers, underscores, and hyphens");
//       setLoadshow("show-n");
//       setOverlayBlock("show-n");
//       return;
//     }
//     try {
//       const response = await redirectURL.post(
//         "masters/addSkuProduct",
//         params
//       );
   
//       if (response.status === 200 && response.data.status === "success") {
//         await getSkuMasterData();
//         setLoadshow("show-n");
//         setOverlayBlock("show-n");
//         setShow(true);
//         setBasicType("success");
//         setBasicTitle("Finished Goods Inventory Product Added Successfully");
//         setRowData((prevRowData) => [...prevRowData, params]);

//       } else {
//          setLoadshow("show-n");
//         setOverlayBlock("show-n");
//         setShow(true);
//         setBasicType("info");
//         setBasicTitle("Failed to add Finished Goods Inventory Product");
//       }
     
//     } catch (error) {
//       setShow(true);
//       setBasicType("info");
//       setBasicTitle("Failed to add Finished Goods Inventory Product");
//     }
//   }

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { sku_code: selectedRow.sku_code };
    try { 
      const response = await redirectURL.post(
        "masters/deleteSKU",
        params
      );
      if (response.data.status === "success") {
        await getSkuMasterData()
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Finished Goods Inventory Product Deleted Successfully");
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete Finished Goods Inventory Product");
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete Finished Goods Inventory Product");
    }


  };

  const onClickDeletePopupCancelBtn = () => {
      setOverlayBlock("show-n");
      setShowDeletePopup(false);
  };

  const setfiltersData = async () => {
    setLoadshow("show-m")
    setOverlayBlock("show-m")
    await getSkuMasterDataByFilters()
    setLoadshow("show-n")
    setOverlayBlock("show-n")
  }


  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
              <SweetAlert
                  show={show}
                  type={basicType}
                  title={basicTitle}
                  onConfirm={closeAlert}
                  style={{ fontSize: "9px" }}
              >
              </SweetAlert>
          </div>

        <div className="row" style={{fontSize: "0.9rem",fontFamily: "Arial, sans-serif"}}>
          <div className="col-sm-12 p-0">
            <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>Finished Goods Inventory</h1>
          </div>
        <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-8 row ">
              <div className="col-sm-3 mb-1" style={{ display: "flex", flexDirection: "column"}}>
               <label
                  style={{ fontSize: "13px", fontWeight: "400"}}
                >
                  Invoice Date:
                </label>
                <input
                  type="date"
                  id="invoiceDate"
                  value={currentinvoiceDate}
                  onChange={(e) => {setPrevDate(currentinvoiceDate); setCurrentInvoiceDate(e.target.value)}}
                  style={{ padding: "7px", borderRadius: "5px", border: "1px solid #d9d9d9", width: "100%", marginBottom: "15px", cursor: "pointer" }}
                  onClick={() => document.getElementById('invoiceDate').showPicker?.()}
                />
              </div>

              <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="storeId" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Destination Store ID:
                </label>
                <Select
                  id="storeId"
                  value={storeId}
                  onChange={(selectedOption) => {setPrevStoreId(storeId); setStoreId(selectedOption)}}
                  options={storeOptions}
                  styles={selectStyles}
                />
              </div>

              <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label  style={{ fontSize: '13px', fontWeight: '400' }}>
                  SKU Code:
                </label>
                <Select
                    value={skuCode}
                    onChange={(selectedOption) => setSkuCode(selectedOption)}
                    options={skuOptions}
                    styles={selectStyles}
                  />
              </div>

            <div className="ml-4 mt-2" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
              <button 
                type="button" 
                onClick={(e) =>{e.preventDefault(); setfiltersData()}}
                style={{
                backgroundColor: "#93385D",
                color: "#fff",
                borderRadius: "5px",
                padding: "8px 20px",
                border: "none",
                cursor: "pointer"
              }}>Apply</button>
              <button 
                onClick={(e)=> {e.preventDefault(); getMainData()}}
                type="button" 
                style={{
                backgroundColor: "#fff",
                color: "#000",
                borderRadius: "5px",
                padding: "8px 20px",
                border: "1px solid #d9d9d9",
                cursor: "pointer"
              }}>Reset</button>
            </div>
             </div>
             <div className="col-sm-4 text-right p-0">
                  <button 
                    onClick={(e) =>{ e.preventDefault(); onClickUploadSkuMasterData()}}
                    className="add-button upload-add-button"
                    >
                    <MdOutlineFileUpload style={{color : "#93385D", fontSize :"18px"}}/>
                  {"Upload Inventory Data"}
                </button>
              </div>
         </form>
              {/* <div className="col-sm-12 mt-2 text-right p-0">
                    <button 
                      onClick={onClickUploadSkuMasterData}
                      className="mr-2 add-button upload-add-button"
                      >
                      <MdOutlineFileUpload style={{color : "#93385D", fontSize :"18px"}}/>
                    {" Upload Sales Data"}
                  </button>
              </div> */}
            <div className="col-sm-12 p-0 pl-2 mt-6">
            
              <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={columnWithDefs}
                    defaultColDef={defaultColDef}
                    domLayout="normal"
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    suppressHorizontalScroll={false} // allow scroll
                    sideBar={sideBar}
                    statusBar={statusPanel}
                    pagination={true}
                    paginationPageSize={100}
                    enableRangeSelection={true}
                    gridOptions={{
                      suppressHorizontalScroll: false
                    }}
                  />
              </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{width : "25%"}}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
          
        </div>

        {sliderType === 2 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflowY: "auto",
                padding: 5,
              }}
            >
              <form style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
                onSubmit={(e) => {e.preventDefault() ; onClickingFileSubmit()}}
              >
              <div className="mb-1" style={{ display: "flex", flexDirection: "column"}}>
                <div className="d-flex justify-content-end mb-10p">
                  <button
                    // className="btn"
                    id="sample-download-button"
                    onClick={downloadExcelTemplate}
                  >
                    Download Excel Template
                  </button>
                </div>
                <label
                    style={{ fontSize: "13px", fontWeight: "400" }}
                  >
                    Date:
                  </label>
                  <input
                    type="date"
                    id="uploadDate"
                    value={currentUploadedDate}
                    onChange={(e) => {setCurrentUploadedDate(e.target.value)}}
                    style={{ padding: "7px", borderRadius: "5px", border: "1px solid #d9d9d9", width: "100%", marginBottom: "15px", cursor: "pointer" }}
                    onClick={() => document.getElementById('uploadDate').showPicker?.()}
                    required
                  />
                </div>
                <input
                  type="file"
                  accept=".csv,.xlsx,.xls"
                  onChange={handleFileChange}
                  style={{
                    border: "1px solid lightgrey",
                    width: "100%",
                    padding: "8px",
                    borderRadius: "5px",
                    backgroundColor: "#f9f9f9",
                    color: "#000",
                    fontSize: "13px",
                  }}
                  id="bulkUploadFile"
                  required
                />
                <p
                  style={{
                    color: "red",
                    fontSize: "13px",
                    margin: "0px",
                    marginTop: "10px",
                  }}
                >
                  *Accept .csv & .xlsx files only
                </p>
              
                <div style={{ textAlign: "right", marginTop: "10px" }}>
                  <button
                    className="btn btn-success"
                    style={{
                      color: "#fff",
                      fontSize: "0.8rem",
                      backgroundColor: "#93385D" 
                    }}
                    type="submit"
                
                  >
                    {"Submit"}
                  </button>
                </div>
              </form>
            </div>
        )}

      </div>
           {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "40%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Are you sure you want to delete ${selectedRow ? selectedRow.sku_code : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
               Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
        <div
          className={"overly-block " + overlyBlock}
          onClick={hideOverlySlideBlock}
        ></div>
    </>
  );
};
const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "7px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily :"sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

const selectStyles = {
    control: (base) => ({
      ...base,
      padding: '1px',
      borderRadius: '5px',
      border: '1px solid #d9d9d9',
    }),
    singleValue: (base) => ({
      ...base,
      fontWeight: 'normal',   // <-- make the text not bold
      color: '#333', 
      fontSize : "12px"         // optional: adjust color
    }),
    option: (base, state) => ({
      ...base,
      fontSize : "13px",
      fontWeight: state.isSelected ? 'normal' : 'normal', // make options also normal if you wish
    })
  }

export default FinishedGoodsInventory;
